import React from 'react';
import { motion } from 'framer-motion';
import { useImages } from '../context/ImageContext';

const MagnetGrid = () => {
  const { images } = useImages();

  return (
    <section id="gallery" className="py-24 bg-parlor-green text-parlor-cream overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-16">
        
        <div className="lg:w-1/2">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-4xl md:text-5xl text-parlor-gold mb-6">Captured & Kept</h2>
            <p className="text-lg text-parlor-cream/80 mb-8 leading-relaxed">
              Witness the joy of your guests as their candid moments are instantly transformed into high-resolution, premium square magnets.
            </p>
            <div className="flex gap-4 items-center">
              <div className="h-px w-12 bg-parlor-gold"></div>
              <span className="text-parlor-gold uppercase tracking-widest text-xs font-bold">The Keepsake Standard</span>
            </div>
          </motion.div>
        </div>

        <div className="lg:w-1/2 relative">
          <div className="grid grid-cols-2 gap-4 md:gap-8 p-4 md:p-8">
            {images.gallery.map((img, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                className={`relative aspect-square bg-white p-3 md:p-4 shadow-magnet transform transition-all duration-500 hover:scale-105 hover:z-10 cursor-pointer ${img.rotation}`}
              >
                <div className="w-full h-full overflow-hidden bg-gray-100 relative group">
                  <img 
                    src={img.url} 
                    alt={img.alt} 
                    className="w-full h-full object-cover filter contrast-110"
                  />
                  <div className="absolute inset-0 bg-parlor-green/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                    <span className="text-white text-xs font-bold uppercase tracking-widest border border-white/40 px-3 py-1">{img.label}</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MagnetGrid;